module.exports = __webpack_public_path__ + "f12d07eba0f4ddd14d97f3594a6e261f.png";